import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { theme } from '../../../domain/theme';

export const Heading = ({ text, fontColor = 'black' }) => {
  const styles = {
    main: css`
      ${theme.font.family('boldWeb')};
      font-size: 32px;
      color: ${fontColor};
      text-align: center;
      letter-spacing: 3.6px;
      line-height: 1.42;
      font-weight: 600;
      max-width: 1080px;
      margin: 20px auto;
      text-transform: uppercase;
      ${theme.mq.small_desktop} {
        font-size: 44px;
        line-height: 1.3;
      }
    `
  };

  return <h2 css={styles.main}>{text}</h2>;
};

Heading.propTypes = {
  text: PropTypes.string.isRequired,
  fontColor: PropTypes.string
};
